module.exports = __webpack_public_path__ + "static/media/consumer.3aefc620.png";